// Localized route table. Slugs translate per language; the keys are the
// internal identifiers used by `pathFor()`. Articles and comparison
// pages have their own helpers because their slugs come from frontmatter.

// Extension explicite : ce module doit rester importable par les scripts Node
// (generate-sitemap derive ses pages statiques d'ici). Vite resout les deux
// formes, Node exige l'extension.
import { categories, getCategoryBySlug } from './categories.js';

export const ROUTES = {
  home:        { fr: '/',                  en: '/en',                 es: '/es' },
  startHere:   { fr: '/commencer-ici',     en: '/en/start-here',      es: '/es/empezar-aqui' },
  // 2026-05-28 — Quiz "Prêt à déménager ?" (uploadé Candice+Eva, porté React).
  // Page dédiée indexable + référencée par les CTAs articles vie-quotidienne.
  quizReady:   { fr: '/quiz-demenager',    en: '/en/move-to-panama-quiz', es: '/es/quiz-mudarse' },
  about:       { fr: '/a-propos',          en: '/en/about',           es: '/es/acerca' },
  flights:     { fr: '/vols-panama',       en: '/en/flights-panama',  es: '/es/vuelos-panama' },
  remoteWork:  { fr: '/travailler-a-distance', en: '/en/remote-work', es: '/es/teletrabajo' },
  gallery:     { fr: '/galerie',           en: '/en/gallery',         es: '/es/galeria' },
  tools:       { fr: '/outils-gratuits',   en: '/en/free-tools',      es: '/es/herramientas-gratuitas' },
  shop:        { fr: '/shop',              en: '/en/shop',            es: '/es/tienda' },
  // Pages produit dédiées (/produit/:slug) — distinctes de /shop/:slug qui est
  // pris par ShopRedirect (redirection Gumroad des CTA articles). Gated par le
  // flag `visible` dans src/data/products.js.
  product:     { fr: '/produit',           en: '/en/product',         es: '/es/producto' },
  comparisons: { fr: '/comparatifs',       en: '/en/comparisons',     es: '/es/comparativas' },
  blog:        { fr: '/blog',              en: '/en/blog',            es: '/es/blog' },
  videos:      { fr: '/videos',            en: '/en/videos',          es: '/es/videos' },
  consulting:  { fr: '/conseil',           en: '/en/consulting',      es: '/es/consultoria' },
  newsletter:  { fr: '/newsletter',        en: '/en/newsletter',      es: '/es/newsletter' },
  resources:   { fr: '/ressources',        en: '/en/resources',       es: '/es/recursos' },
  bookmarks:   { fr: '/favoris',           en: '/en/favorites',       es: '/es/favoritos' },
  monPanama:   { fr: '/mon-panama',         en: '/en/my-panama',       es: '/es/mi-panama' },
  history:     { fr: '/histoire',          en: '/en/history',         es: '/es/historia' },
  methodology: { fr: '/methodologie',      en: '/en/methodology',     es: '/es/metodologia' },
  map:         { fr: '/carte',             en: '/en/map',             es: '/es/mapa' },
  preview:     { fr: '/preview',           en: '/en/preview',         es: '/es/preview' },
  pressKit:    { fr: '/press-kit',         en: '/en/press-kit',       es: '/es/press-kit' },
  // Place pages — landmarks, parks, neighbourhoods. Slug stays Spanish
  // (parque-urraca, cinta-costera) across all locales because that's what
  // users actually type into Google regardless of UI language. The route
  // segment ("lieux"/"places"/"lugares") localises.
  places:      { fr: '/lieux',             en: '/en/places',          es: '/es/lugares' },
  // Legal slugs are stable across languages — same Markdown file lookup.
  legalPrivacy:    { fr: '/legal/privacy-policy',        en: '/en/legal/privacy-policy',        es: '/es/legal/privacy-policy' },
  legalTerms:      { fr: '/legal/terms-of-service',      en: '/en/legal/terms-of-service',      es: '/es/legal/terms-of-service' },
  legalDisclosure: { fr: '/legal/affiliate-disclosure',  en: '/en/legal/affiliate-disclosure',  es: '/es/legal/affiliate-disclosure' },
  legalCookies:    { fr: '/legal/cookie-policy',         en: '/en/legal/cookie-policy',         es: '/es/legal/cookie-policy' },
  legalContact:    { fr: '/legal/contact',               en: '/en/legal/contact',               es: '/es/legal/contact' },
  legalNotice:     { fr: '/legal/legal-notice',          en: '/en/legal/legal-notice',          es: '/es/legal/aviso-legal' },
  legalRefund:     { fr: '/legal/refund-policy',         en: '/en/legal/refund-policy',         es: '/es/legal/politica-reembolso' },
  legalPhotos:     { fr: '/legal/photos',                en: '/en/legal/photos',                es: '/es/legal/fotos' },
  // Voyage / Premier Voyage — touristes + futurs expats (avant la décision)
  voyage:          { fr: '/voyage',                      en: '/en/travel',                       es: '/es/viaje' },
  // Partenaires B2B — marques + entreprises (sponsoring, consulting, audits)
  partenaires:     { fr: '/partenaires',                 en: '/en/partners',                     es: '/es/socios' },
  // Enfants & familles — s'expatrier avec enfants, écoles, santé pédiatrique, vie famille
  enfants:         { fr: '/enfants',                     en: '/en/family',                       es: '/es/ninos' },
  // 2026-05-26 — Sales landing page Pack Entrepreneur ($49 — pack_business_setup)
  // URL punchy pour campagne marketing (vs route shop/produit générique).
  packEntrepreneur: { fr: '/pack-entrepreneur',          en: '/en/entrepreneur-pack',            es: '/es/pack-emprendedor' },
  // 2026-05-26 — Audit design Sprint 3 (C·03+) : un outil = une URL.
  // Avant : 4 tuiles home pointaient toutes vers /outils. Mauvais SEO
  // (1 page vs 4 requêtes), mauvaise UX (re-navigation à la cible).
  // Maintenant : chaque outil a sa propre page indexable.
  toolBudget:    { fr: '/outils-gratuits/budget-panama',       en: '/en/free-tools/panama-budget',         es: '/es/herramientas-gratuitas/presupuesto-panama' },
  toolConverter: { fr: '/outils-gratuits/convertisseur-eur-usd', en: '/en/free-tools/eur-usd-converter',   es: '/es/herramientas-gratuitas/convertidor-eur-usd' },
  toolVisa:      { fr: '/outils-gratuits/checklist-visa',     en: '/en/free-tools/visa-checklist',        es: '/es/herramientas-gratuitas/checklist-visa' },
  toolDog:       { fr: '/outils-gratuits/importer-chien',     en: '/en/free-tools/import-dog',            es: '/es/herramientas-gratuitas/importar-perro' },
  // Plan du site (Sprint 4) — toutes les pages avancées en un seul endroit.
  // Référencé par le Footer slim.
  // 2026-07-19 — Les ~1 150 paires question/reponse du corpus, reunies et
  // interrogeables. Elles n'etaient lisibles qu'en bas de l'article porteur ;
  // cette page les rend balayables ET indexables sur des requetes formulees
  // en question (longue traine + citations IA).
  questions:     { fr: '/questions',                          en: '/en/questions',                        es: '/es/preguntas' },
  sitemap:       { fr: '/plan-du-site',                       en: '/en/sitemap',                          es: '/es/mapa-del-sitio' },
  // 2026-05-29 — Page goodies gratuits : fonds d'écran + kit logo téléchargeables.
  // Brand-affinity + capture newsletter douce. Assets dans public/brand/.
  downloads:     { fr: '/telechargements',                   en: '/en/downloads',                        es: '/es/descargas' },
  // 2026-06-25 — Landing pensionado / retraite, complément du mode confort
  // pour l'audience retraitée (produit Pensionado Plus). SEO : « prendre sa
  // retraite au Panama » / « retire in Panama » / « jubilarse en Panamá ».
  retirees:      { fr: '/retraite-panama',                   en: '/en/retire-in-panama',                 es: '/es/jubilarse-en-panama' },
  // 2026-06-26 — Roadmap gamifiée par persona (idée #4 audit Jade). Page
  // dédiée car StartHere a un bug pré-existant à débugger séparément.
  myRoadmap:     { fr: '/ma-roadmap',                        en: '/en/my-roadmap',                       es: '/es/mi-hoja-de-ruta' },
  // 2026-07-09 — Landing lead magnet « Move in 60 Days » (cours email gratuit,
  // capture → séquence Beehiiv source=move-in-60-days). Chemin critique G1.
  move60:        { fr: '/s-installer-en-60-jours',           en: '/en/move-in-60-days',                  es: '/es/instalarse-en-60-dias' },
  // 2026-07-10 — Page RÉSERVÉE (noindex) du programme lecteurs-testeurs pré-lancement.
  // Le lien à envoyer aux volontaires. Mécanique : docs/strategy/BETA_LECTEURS.md.
  programmeLecteurs: { fr: '/programme-lecteurs',            en: '/en/reader-program',                   es: '/es/programa-lectores' },
};

const LANG_PREFIXES = { fr: '', en: '/en', es: '/es' };

/**
 * Build a localized path for a given route key.
 *
 * For `article`: pass `{ category, slug }` — the helper resolves the
 * category's `pathSlug[lang]` and returns `/[catSlug]/[articleSlug]`.
 *
 * For `comparison`: pass `{ slug }` — returns the comparison hub path
 * with `slug` appended.
 *
 * @param {string} key
 * @param {'fr'|'en'|'es'} lang
 * @param {object} [params]
 *
 * @example
 *   pathFor('home', 'es')
 *   // → '/es'
 *   pathFor('article', 'fr', { category: 'banque-argent', slug: 'ouvrir-compte-bancaire-panama' })
 *   // → '/banque-argent/ouvrir-compte-bancaire-panama'
 */
export function pathFor(key, lang = 'fr', params = {}) {
  if (key === 'article') {
    const cat = getCategoryBySlug(params.category);
    const catSlug = cat?.pathSlug[lang] ?? params.category;
    const prefix = LANG_PREFIXES[lang] ?? '';
    return `${prefix}/${catSlug}/${params.slug}`;
  }
  if (key === 'comparison') {
    const base = ROUTES.comparisons[lang];
    return `${base}/${params.slug}`;
  }
  if (key === 'product') {
    // Page produit dédiée : /produit/:slug (· /en/product · /es/producto)
    const base = ROUTES.product[lang];
    return `${base}/${params.slug}`;
  }
  if (key === 'author') {
    const segment = lang === 'en' ? 'authors' : lang === 'es' ? 'autores' : 'auteurs';
    const prefix = LANG_PREFIXES[lang] ?? '';
    return `${prefix}/${segment}/${params.slug}`;
  }
  if (key === 'lead') {
    const prefix = LANG_PREFIXES[lang] ?? '';
    return `${prefix}/lead/${params.slug}`;
  }
  if (key === 'place') {
    const base = ROUTES.places[lang];
    return `${base}/${params.slug}`;
  }
  if (key === 'category') {
    const cat = getCategoryBySlug(params.slug);
    const catSlug = cat?.pathSlug[lang] ?? params.slug;
    const prefix = LANG_PREFIXES[lang] ?? '';
    return `${prefix}/${catSlug}`;
  }
  return ROUTES[key]?.[lang] ?? '/';
}

/**
 * Returns ALL category path slugs across languages — used by App.jsx to
 * register routes. Each category claims `/{pathSlug}` (and `/{pathSlug}/:slug`
 * for articles inside it).
 */
export function categoryPathSlugsForLang(lang) {
  return categories.map((c) => c.pathSlug[lang]);
}
